<template>
    <div 
        id="pyramid-wrapper"
        :class="{ 'animate': doAnimate }"    
    >
        <svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 698.38 698.38">
            <defs>
                <radialGradient id="radial-gradient" cx="349.43" cy="218.5" fx="349.43" fy="218.5" r="412.53" gradientUnits="userSpaceOnUse">
                    <stop offset="0" stop-color="#de00df"/>
                    <stop offset="1" stop-color="#5500df"/>
                </radialGradient>
                <radialGradient id="radial-gradient-2" r="412.53" xlink:href="#radial-gradient"/>
                <radialGradient id="radial-gradient-3" cx="349.43" cy="218.5" fx="349.43" fy="218.5" r="412.53" xlink:href="#radial-gradient"/>
                <radialGradient id="radial-gradient-4" cx="349.43" cy="218.5" fx="349.43" fy="218.5" r="412.53" xlink:href="#radial-gradient"/>
                <radialGradient id="radial-gradient-5" cx="349.43" fx="349.43" r="412.53" xlink:href="#radial-gradient"/>
                <radialGradient id="radial-gradient-6" cx="349.43" fx="349.43" r="412.53" xlink:href="#radial-gradient"/>
                <radialGradient id="radial-gradient-7" cx="349.43" cy="218.5" fx="349.43" fy="218.5" r="412.53" xlink:href="#radial-gradient"/>
                <radialGradient id="radial-gradient-8" cx="381.39" cy="74.11" fx="381.39" fy="74.11" r="17.33" xlink:href="#radial-gradient"/>
                <radialGradient id="radial-gradient-9" cx="297.08" cy="357.42" fx="297.08" fy="357.42" r="9.76" xlink:href="#radial-gradient"/>
                <radialGradient id="radial-gradient-10" cx="198.59" cy="188.22" fx="198.59" fy="188.22" r="9.46" xlink:href="#radial-gradient"/>
                <radialGradient id="radial-gradient-11" cx="349.43" cy="218.5" fx="349.43" fy="218.5" r="412.53" xlink:href="#radial-gradient"/>
                <radialGradient id="radial-gradient-12" cx="349.43" cy="218.5" fx="349.43" fy="218.5" r="412.53" xlink:href="#radial-gradient"/>
                <linearGradient id="linear-gradient" x1="162.75" y1="723.3" x2="447.5" y2="205.9" gradientUnits="userSpaceOnUse">
                    <stop offset="0" stop-color="#adbc88"/>
                    <stop offset="1" stop-color="#000"/>
                </linearGradient>
            </defs>
            <g id="sky">
                <path class="pyramid-17" d="M349.19,0C156.34,0,0,156.34,0,349.19,0,361.65.67,373.95,1.94,386.07h694.51c1.27-12.12,1.94-24.42,1.94-36.88C698.38,156.34,542.04,0,349.19,0Z"/>
            </g>
            <g id="galaxy">
                <path class="pyramid-9" d="M313.1,179.15c15.72-2.14,32.36,5.99,41.87,18.38,3.87,5.04,3.74,9.1-1.21,13.39-8.86,7.68-12.82-2.69-18.19-7.75-10.71-10.1-27.17-9.6-32.96,5.13-9.65,24.58,28.64,58.2,47.14,69.67,44.7,27.69,120.6,24.68,137.22-34.14,2.27-8.04,1.43-22.98,13.37-21.03,10.61,1.73,6.22,16.99,4.42,24.26-26.3,106.41-187.96,75.28-218.99-13.5-7.95-22.73,1.09-50.84,27.32-54.41Z"/>
                <path class="pyramid-8" d="M270.26,128.22c42.01-3.71,87.18,15.11,115.44,45.85,14.39,15.65,28.63,36.07,24.45,58.45-6.44,34.48-45.91,37.74-67.77,14.8-5.33-5.59-8.69-12.44-.74-17.79s12.16,3.93,17.38,8.43c22.43,19.34,42.29-5.27,29.64-30.45-24.95-49.66-106.84-82.13-154.57-46.71-6.71,4.98-14.31,17.67-22.76,9.68-9.55-9.03,6.57-20.38,13.54-25.37,13.07-9.36,29.28-15.47,45.39-16.89Z"/>
                <path class="pyramid-7" d="M231.85,88.09c-2.89-2.55-3.87-9.59-1.42-12.65,4.62-5.75,30.4-9.35,37.98-9.74,49.8-2.57,111.31,35.97,140.19,74.96,4.44,5.99,14.3,17.03,7.05,23.75-10.28,9.52-17.49-7.71-22.43-14.04-28.54-36.56-85.46-72.49-133.5-65.85-6.55.9-16.94,5.38-22.11,5.48-1.77.03-4.47-.76-5.77-1.91Z"/>
                <path class="pyramid-4" d="M289.56,276.29c3.78,3.93,8.45,12.88,12.44,17.9,27.67,34.85,80.03,66.32,125.75,62.7,7.31-.58,30.87-8.68,34.78.03,3.66,8.14-4.17,12.71-10.74,14.31-53.34,12.94-109.92-12.66-148.21-48.69-6.92-6.51-30.23-32.35-29.87-41.19.31-7.49,10.16-10.95,15.85-5.05Z"/>
                <path class="pyramid-3" d="M258.01,211.57c6.1,6.34-3.01,14.33-5.82,19.91-13.07,25.96,4.2,65.43,19.02,87.83,2.68,4.05,12.14,14.46,12.81,17.98,1.35,7.1-8.1,14.16-14.74,8.22-6.83-6.11-18.66-24.9-23.26-33.36-16.18-29.76-26.1-62.61-6.98-93.81,4.25-6.94,11.15-14.88,18.98-6.76Z"/>
                <path class="pyramid-2" d="M414.18,92.55c6.81-1.55,11.71,6.02,15.58,10.77,24.9,30.59,46.82,82.23,23.82,119.22-3.97,6.39-8.41,12.53-16.46,6.89-9.28-6.5.16-13.91,3.33-20.83,12.46-27.24-2.14-62.78-18.1-85.75-3.23-4.64-15.37-17.49-15.17-21.92.14-3.11,4.03-7.72,7-8.39Z"/>
                <path class="pyramid-1" d="M475.33,358.26c-2.89-2.56-3.5-7.96-1.76-11.37,1.95-3.84,5.83-3.83,9.08-5.48,4.05-2.05,14.76-8.71,18.1-9.41,6.51-1.36,11.77,4.31,10.56,10.54-1.07,5.55-12.36,11.19-17.34,13.43s-13.67,6.69-18.65,2.29Z"/>
                <path class="pyramid-6" d="M368.88,58.57c5.58-1.24,12.17,3.45,16.66,6.46,6.38,4.26,21.03,14.08,11.5,22.53-7.35,6.52-13.99-2.56-19.59-6.35-4.02-2.72-14.11-7.25-14.78-11.94-.57-3.96,2.04-9.76,6.21-10.69Z"/>
                <path class="pyramid-5" d="M304.13,350.7c8.42,8.83-4.34,22.03-13.52,13.92-9.9-8.76,4.63-23.23,13.52-13.92Z"/>
                <path class="pyramid-12" d="M195.79,179.13c14.42-2.97,16.2,16,5.29,18.23-13.21,2.7-16.34-15.95-5.29-18.23Z"/>
                <path class="pyramid-13" d="M497.52,195.3c13.78-2.82,15.76,17.45,3.65,19.09s-15.16-16.73-3.65-19.09Z"/>
                <path class="pyramid-11" d="M359.98,315.82c14.43-3.3,13.53,19.22-.62,14.83-6.72-2.09-6.35-13.24.62-14.83Z"/>
            </g>
            <polygon id="starburst" class="pyramid-18" points="350.16 109.59 371.99 69.43 380.35 114.37 413.53 82.92 407.59 128.25 448.87 108.59 429.21 149.87 474.54 143.93 443.09 177.11 488.03 185.46 447.87 207.3 488.03 229.14 443.09 237.5 474.54 270.68 429.21 264.74 448.87 306.01 407.59 286.36 413.53 331.68 380.35 300.24 371.99 345.18 350.16 305.02 328.32 345.18 319.96 300.24 286.78 331.68 292.72 286.36 251.45 306.01 271.1 264.74 225.78 270.68 257.22 237.5 212.28 229.14 252.44 207.3 212.28 185.46 257.22 177.11 225.78 143.93 271.1 149.87 251.45 108.59 292.72 128.25 286.78 82.92 319.96 114.37 328.32 69.43 350.16 109.59"/>
            <path id="ground" class="pyramid-20" d="M349.19,698.38c180.39,0,328.83-136.79,347.25-312.31H1.94c18.43,175.51,166.86,312.31,347.25,312.31Z"/>
            <path id="pyramid-shadow" class="pyramid-10" d="M522.03,530.21l-282.61,145.65s-128.02-42.26-202.47-183.71l125.76-10.39,359.32,48.45Z"/>
            <path id="front-border" class="pyramid-15" d="M349.19,22.52c44.11,0,86.89,8.63,127.15,25.66,38.9,16.45,73.84,40.01,103.84,70.02,30.01,30.01,53.57,64.95,70.02,103.84,17.03,40.26,25.66,83.04,25.66,127.15s-8.63,86.89-25.66,127.15c-16.45,38.9-40.01,73.84-70.02,103.84-30.01,30.01-64.95,53.57-103.84,70.02-40.26,17.03-83.04,25.66-127.15,25.66s-86.89-8.63-127.15-25.66c-38.9-16.45-73.84-40.01-103.84-70.02-30.01-30.01-53.57-64.95-70.02-103.84-17.03-40.26-25.66-83.04-25.66-127.15s8.63-86.89,25.66-127.15c16.45-38.9,40.01-73.84,70.02-103.84,30.01-30.01,64.95-53.57,103.84-70.02,40.26-17.03,83.04-25.66,127.15-25.66M349.19,0C156.34,0,0,156.34,0,349.19s156.34,349.19,349.19,349.19,349.19-156.34,349.19-349.19S542.04,0,349.19,0h0Z"/>
            <g id="all-knowing-eye">
                <polygon class="pyramid-14" points="282.09 239.65 348.3 151.41 417.97 239.65 282.09 239.65"/>
                <path class="pyramid-19" d="M348.38,157.87l61.46,77.84h-119.87l58.41-77.84M348.22,144.95l-74.02,98.64h151.9l-77.88-98.64h0Z"/>
                <g id="eye">
                    <path class="pyramid-19" d="M348.45,185.87c13.41-.83,29.81,7.24,39.47,16.24,5.37,5.01,5.5,5.9,0,10.93-23.55,21.51-55.71,21.21-77.9-2.17-3.16-3.33-1.44-5.21,1.33-7.89,9.25-8.95,24.17-16.32,37.11-17.11ZM335.85,195.78c-1.3-1-12.64,6.36-14.4,7.68-.74.55-4.39,3.36-4.45,3.9s-.02.72.33,1.12c1.46,1.65,7.24,5.43,9.37,6.7,1.67,1,6.88,3.95,8.49,4.19s-.93-2.86-1.25-3.56c-3.43-7.3-2.31-13.38,1.91-20.03ZM364.29,219.36c1.54,1.21,17.59-9.05,19.22-11.63.18-1.07-8.2-6.89-9.63-7.77-1.62-.99-6.92-3.95-8.5-4.19-1.72-.26.64,2.49.89,3.04,3.36,7.47,2.83,13.86-1.99,20.54ZM347.98,196.32c-13.88,2.63-10.62,24.13,3.36,22.57,15.47-1.73,11.81-25.44-3.36-22.57Z"/>
                    <path class="pyramid-14" d="M347.98,196.32c15.16-2.87,18.83,20.84,3.36,22.57-13.97,1.56-17.24-19.94-3.36-22.57ZM347.55,204.84c-1.85,1.76-5.37-1.97-4.66,3.79,1.07,8.74,15.8,8.65,14.41-2.59-.7-5.68-9.41-7.32-9.53-4.8-.03.58,1.49,1.98-.21,3.6Z"/>
                    <path class="pyramid-14" d="M364.29,219.36c4.82-6.68,5.35-13.06,1.99-20.54-.25-.56-2.61-3.3-.89-3.04,1.57.24,6.88,3.2,8.5,4.19,1.43.87,9.81,6.69,9.63,7.77-1.63,2.58-17.68,12.84-19.22,11.63Z"/>
                    <path class="pyramid-14" d="M335.85,195.78c-4.22,6.65-5.34,12.73-1.91,20.03.33.7,2.89,3.8,1.25,3.56s-6.83-3.19-8.49-4.19c-2.13-1.27-7.9-5.04-9.37-6.7-.36-.4-.4-.57-.33-1.12s3.71-3.34,4.45-3.9c1.76-1.31,13.1-8.68,14.4-7.68Z"/>
                    <path class="pyramid-19" d="M347.55,204.84c1.71-1.62.19-3.02.21-3.6.12-2.53,8.83-.88,9.53,4.8,1.39,11.24-13.34,11.33-14.41,2.59-.71-5.76,2.81-2.03,4.66-3.79Z"/>
                </g>
            </g>
            <g id="pyramid">
                <polygon class="pyramid-16" points="217.12 526.27 318.73 287.87 419.45 287.87 516.18 526.27 217.12 526.27"/>
                <path class="pyramid-15" d="M416.8,291.81l93.53,230.52H223.08l98.25-230.52h95.47M422.11,283.93h-105.98l-104.97,246.28h310.88l-99.92-246.28h0Z"/>
                <polygon class="pyramid-15" points="316.13 283.93 282.82 283.93 162.71 481.76 211.15 530.21 316.13 283.93"/>
                <path class="pyramid-15" d="M500.84,483.95h-73.77v-33.35h60.6v-6.82h-30.3v-33.35h13.94v-6.82h-43.84v-33.35h26.49v-6.82h-58.61v-33.35h41.26v-6.82h-65.94v-36.1h-6.82v36.1h-65.94v6.82h35.61v33.35h-49.91v6.82h17.93v33.35h-34.25v6.82h9.5v33.35h-30.53v6.82h58.15v33.35h-73.04v6.82h47.27v36.76h6.82v-36.76h46.03v34.98h6.82v-34.98h51.1v36.76h6.82v-36.76h51.1v36.1h6.82v-36.1h46.69v-6.82ZM420.25,483.95h-51.1v-33.35h51.1v33.35ZM392.63,410.43v33.35h-51.1v-33.35h51.1ZM450.55,443.78h-51.1v-33.35h51.1v33.35ZM420.65,403.61h-50.56v-33.35h50.56v33.35ZM340.35,330.09h48.18v33.35h-48.18v-33.35ZM308.37,370.26h54.9v33.35h-54.9v-33.35ZM283.62,410.43h51.1v33.35h-51.1v-33.35ZM311.24,450.6h51.1v33.35h-51.1v-33.35Z"/>
                <rect class="pyramid-16" x="243.84" y="490.78" width="244.2" height="31.7"/>
                <path class="pyramid-15" d="M293.13,506.78l-5.8-10.55h7.63l1.97,3.57,1.97-3.57h7.67l-5.8,10.55,6.23,11.3h-7.63l-2.42-4.36-2.39,4.36h-7.63l6.23-11.3Z"/>
                <path class="pyramid-15" d="M313.54,506.78l-5.8-10.55h7.63l1.97,3.57,1.97-3.57h7.67l-5.8,10.55,6.23,11.3h-7.63l-2.42-4.36-2.39,4.36h-7.63l6.23-11.3Z"/>
                <path class="pyramid-15" d="M327.89,496.23h7.4v21.85h-7.4v-21.85Z"/>
                <path class="pyramid-15" d="M337.59,496.23h7.27v16.12h6.03v5.73h-13.3v-21.85Z"/>
                <path class="pyramid-15" d="M352.04,496.23h7.4v21.85h-7.4v-21.85Z"/>
                <path class="pyramid-15" d="M366.16,506.78l-5.8-10.55h7.63l1.97,3.57,1.97-3.57h7.67l-5.8,10.55,6.23,11.3h-7.63l-2.42-4.36-2.39,4.36h-7.63l6.23-11.3Z"/>
                <path class="pyramid-15" d="M380.51,496.23h7.27v16.12h6.03v5.73h-13.3v-21.85Z"/>
                <path class="pyramid-15" d="M394.96,496.23h7.27v16.12h6.03v5.73h-13.3v-21.85Z"/>
                <path class="pyramid-15" d="M411.8,496.23l3.7,9.5,3.73-9.5h7.63l-8.52,21.85h-5.67l-8.52-21.85h7.63Z"/>
                <path class="pyramid-15" d="M427.36,496.23h5.77l5.7,8.39,5.67-8.39h5.77v21.85h-6.98v-7.86l-4.46,6.55-4.49-6.55v7.86h-6.98v-21.85Z"/>
            </g>
            <g id="stars">
                <polygon id="large-star" class="pyramid-14" points="564.68 165.43 571.39 207.27 589.51 213.97 571.39 220.68 564.68 265.45 557.98 220.68 539.86 213.97 557.98 207.27 564.68 165.43"/>
                <circle id="star-1" class="pyramid-14" cx="159.12" cy="143.02" r="11.64"/>
                <circle id="star-2" class="pyramid-14" cx="93.51" cy="246.26" r="5.82"/>
                <circle id="star-3" class="pyramid-14" cx="164.94" cy="294.31" r="5.82"/>
                <circle id="star-4" class="pyramid-14" cx="652.88" cy="313.39" r="4.82"/>
            </g>
        </svg>
    </div>
</template>

<script>
export default {
  name: 'badge-8',
  data() {
    return {
            counter: 0,
            intervalId: null,
            doAnimate: false,
        }
    },
    mounted() {
        this.intervalId = setInterval(() => {
            this.doAnimate = true
            
            setTimeout(() => {
                this.doAnimate = false
            }, 8000)
        }, 15000)

        this.doAnimate = true
        setTimeout(() => {
            this.doAnimate = false
        }, 5000)
    },
    beforeUnmount() {
        clearInterval(this.intervalId)
    },
}
</script>

<style>

#pyramid-wrapper {
    --darkBlue: #111642;
}

#pyramid-wrapper * {
    transition: all 0.3s;
}

#all-knowing-eye,
#starburst,
#pyramid-shadow {
    opacity: 0;
}

.animate #all-knowing-eye,
#pyramid-wrapper:hover #all-knowing-eye,
.animate #starburst,
#pyramid-wrapper:hover #starburst,
.animate #pyramid-shadow,
#pyramid-wrapper:hover #pyramid-shadow {
    opacity: 1;
}

#all-knowing-eye {
    transform: translateY(-20px);
}

.animate #all-knowing-eye,
#pyramid-wrapper:hover #all-knowing-eye {
    transform: translateY(0);
}

.animate #galaxy {
    opacity: 0;
}

#pyramid-wrapper:hover #galaxy {
    opacity: 0 !important;
}

/* Eye blink animation */
@keyframes blink {
    0%, 90%, 100% {
        opacity: 1;
    }
    95% {
        opacity: 0;
    }
}

.animate #eye,
#pyramid-wrapper:hover #eye {
    animation: blink 2s ease-in-out infinite;
    transform-origin: center;
    transition: opacity 0;
}

.animate #front-border {
    fill: white;
}

/* Starburst rotation and swell animation */
@keyframes starburst-spin {
    0% {
        transform: rotate(0deg) scale(1);
    }
    50% {
        transform: rotate(180deg) scale(1.15);
    }
    100% {
        transform: rotate(360deg) scale(1);
    }
}

.animate #starburst {
    opacity: 1;
    animation: starburst-spin 4s ease-in-out infinite;
    transform-origin: center;
}

#ground {
    fill: #353f1e;
}

.animate #ground {
    fill: #adbc88;
}

#stars {
    transform: translateY(20px);
    opacity: 0;
}

.animate #stars,
#pyramid-wrapper:hover #stars {
    opacity: 1;
    transform: translateY(0);
}

@keyframes twinkle {
    0%, 100% {
        opacity: 1;
        transform: translateY(0);
    }
    50% {
        opacity: 0.2;
        transform: translateY(10px);
    }
}
#pyramid-wrapper:hover #star-1, 
.animate #star-1 {
    animation: twinkle 1.8s ease-in-out infinite;
}

#pyramid-wrapper:hover #star-2,
.animate #star-2 {
    animation: twinkle 2.3s ease-in-out infinite 0.4s;
}

#pyramid-wrapper:hover #star-3,
.animate #star-3 {
    animation: twinkle 1.5s ease-in-out infinite 0.9s;
}

#pyramid-wrapper:hover #star-4,
.animate #star-4 {
    animation: twinkle 2.1s ease-in-out infinite 1.2s;
}

#pyramid-wrapper:hover #large-star,
.animate #large-star {
    animation: twinkle 2.5s ease-in-out infinite 0.6s;
}

.pyramid-1 {
	fill: url(#radial-gradient-7);
}

.pyramid-2 {
	fill: url(#radial-gradient-6);
}

.pyramid-3 {
	fill: url(#radial-gradient-5);
}

.pyramid-4 {
	fill: url(#radial-gradient-4);
}

.pyramid-5 {
	fill: url(#radial-gradient-9);
}

.pyramid-6 {
	fill: url(#radial-gradient-8);
}

.pyramid-7 {
	fill: url(#radial-gradient-3);
}

.pyramid-8 {
	fill: url(#radial-gradient-2);
}

.pyramid-9 {
	fill: url(#radial-gradient);
}

.pyramid-10 {
	fill: url(#linear-gradient);
}

.pyramid-11 {
	fill: url(#radial-gradient-12);
}

.pyramid-12 {
	fill: url(#radial-gradient-10);
}

.pyramid-13 {
	fill: url(#radial-gradient-11);
}

.pyramid-14 {
	fill: #fff;
}

.pyramid-15 {
	fill: var(--darkBlue);
}

.pyramid-16 {
    fill: #202769;
}

.animate .pyramid-16 {
    fill: #efdbb9;
}

.pyramid-17 {
	fill: #42457c;
}

.pyramid-18 {
	fill: #f9b938;
}

.pyramid-19 {
	fill: #282b4c;
}

.pyramid-20 {
	fill: #adbc88;
}
</style>